'use client'

import dayjs from 'dayjs'
import { setCookie } from 'cookies-next'
import { useTheme } from 'next-themes'
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  function themeChanged() {
    const theme = (resolvedTheme === 'dark' ? 'light' : 'dark')
    setTheme(theme)
    setCookie('theme', theme, { expires: dayjs().add(1, 'year').toDate() })
  }
  return (
    <button type='button' className='menu-button' onClick={themeChanged} aria-label="Toggle theme"  >
      <MoonIcon className='size-5 md:size-4 stroke-z-900 dark:hidden' />
      <SunIcon className='hidden size-5 md:size-4 stroke-white dark:block' />
      <span className='pl-2 text-sm hidden md:block dark:hidden'>Dark Mode</span>
      <span className='pl-2 text-sm hidden dark:md:block'>Light Mode</span>
    </button>
  )
}
